//封装操作localstorage本地存储的方法   模块化的文件


// nodejs  基础



var storage = {

    set(key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (e) {
            console.error("保存缓存出错，key=" + key, value, e);
            return null;
        }
    },
    get(key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        }
        catch (e) {
            console.error("读取缓存出错，key=" + key, e);
            return null;
        }
    }, remove(key) {
        try {
            localStorage.removeItem(key);
        }
        catch (e) {
            console.error("删除缓存出错，key=" + key, e);
            return null;
        }
    }

}

export default storage;


